import { CreatureType } from "../enums/creature.type";
import { RarityType } from "../enums/rarity.type";

export interface AbilityDto {
    id: string;
    rarity: RarityType;
    loops: number;
    coolDown: number;
    frameVisualId: number;
    iconVisualId: number;
    descriptionVisualId: number;
    name: string;
    nameTranslations?: any;
    description: string;
    descriptionTranslations?: any;
    imageUrl: string;
    phases: AbilityPhaseDto[];
    applyToCreatureTypes: CreatureType[];
    isAvailableForReshuffle: boolean;
}

export enum AbilityDamageType {
    Physical,
    Fire,
    Poison,
    Heal,
}

export enum AbilityApplicatorType {
    Damage,
    Heal,
    CasterHealthBasedDamage,
    SelfHeal,
    Cure,
    AddActionPoint,
    SelfDamage,
}

export interface AbilityPhaseDto {
    targetSelectorType: number
    creaturesToSelect: number
    rangeType: number
    trajectoryType: number
    startVfxName?: string
    startAudioName?: string
    projectileVfxName?: string
    projectileAudioName: any
    projectleVFXDuration: number
    endVfxName: string
    endAudioName?: string
    applicators: Applicator[]
    effectorsToApplyAtCaster: EffectorsToApplyAtCaster[]
    effectorsToRemoveFromCaster: any[]
    effectorsToApplyAtTargets: EffectorsToApplyAtTarget[]
    effectorsToRemoveFromTargets: any[]
}



export interface Applicator {
    applicatorType: AbilityApplicatorType
    damageType: AbilityDamageType
    damageTable: any
    min: number
    max: number
}

export interface EffectorsToApplyAtCaster {
    id: string
    type: number
    placement: number
    icon: number
    applyParticlesVfxName: any
    updateParticlesVfxName: any
    removeParticlesVfxName: any
    durationInTurns: number
    damageType: number
    effectorData: any
    percentage: number
    chanceToAttackDifferentTarget: number
    healthChange: number
    breakOnDamage: boolean
}

export interface EffectorsToApplyAtTarget {
    id: string
    type: number
    placement: number
    icon: number
    applyParticlesVfxName: string
    updateParticlesVfxName: any
    removeParticlesVfxName: any
    durationInTurns: number
    damageType: number
    effectorData: any
    percentage: number
    chanceToAttackDifferentTarget: number
    healthChange: number
    breakOnDamage: boolean
}